
import { useContext, useState, useRef, useEffect } from "react";
import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
faBars
} from '@fortawesome/free-solid-svg-icons';
import UserContext from '../../../hooks/UserContext';
import ConfirmButton from "../../../components/ConfirmButton";
import UserCard from "../../../components/UserCard";
import useClickOutside from "../../../hooks/useDocumentClick";

const styles = css`
display: flex;
flex-direction: column;
gap: 5px;
width: 100%;
& .member {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  position: relative;
  > .member-card {
    &.selected {
      background-color: #eeeeee;
    }
  }
  > .menu-button {
    position: absolute;
    right: 10px;
    display: flex;
    padding: 10px;
    > .menu {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      > .buttons {
        z-index: 10;
        position:absolute;
        display: none;
        border: 1px solid gray;
        background-color: white;
        border-radius: 3px;
        padding: 10px;
        top: -10px;
        right: 0px;
        &.open {
          display: flex;
          flex-direction: column;
          gap: 15px;
          
        }
        > .menu-item {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          flex-flow: nowrap;
          > .label {
            display: flex;
          }
        }
      }
    }
  }

  & .owner {
    font-weight: bold;
    border-width: 3px;
  }
}
`
const MemberPanel = styled(({ className, group, onRemoveMember, onAddAdmin }) => {

  const MemberCard = ({ member, onRemoveMember, onAddAdmin }) => {
    const { user } = useContext(UserContext);
    const menuRef = useRef(null);
    const documentClicked = useClickOutside(menuRef);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const isOwner = group?.owner?._id === user?._id;
    const memberIsUser = member._id === user._id;
    const memberIsOwner = member._id === group?.owner?._id;
    const canRemove = (memberIsUser || isOwner) && (!memberIsOwner);
    const canAddAdmin = isOwner && !memberIsOwner;

    const removeLabel = memberIsUser
    ? 'Leave Group'
    : 'Remove User';
    const removeText = memberIsUser
      ? `Do you want to leave the group "${group.name}"?`
      : `Do you want to remove ${member.firstname} ${member.lastname} from "${group.name}"?`;

    const hasMenu = canRemove || canAddAdmin;

    const buttons = [];
     
    const toggleMenu = () => {
      setIsMenuOpen(!isMenuOpen);
    }

    const handleRemoveMember = (memberId) => {
      toggleMenu();
      onRemoveMember(memberId);
    }

    const handleAddAdmin = (memberId) => {
      onAddAdmin(memberId);
      toggleMenu();
    }

    useEffect (() => {
      if (documentClicked) setIsMenuOpen(false);
    }, [documentClicked])

    if (canRemove) {
      buttons.push(
        <div className='menu-item'>
          <ConfirmButton className='button danger'
            text={removeText}
            confirm='Yes'
            cancel='No'
            onConfirm={() => handleRemoveMember(member._id)}
            onCancel={toggleMenu}>
            <span className='label'>
              {removeLabel}
            </span>
          </ConfirmButton>
        </div>)
    }

    if (canAddAdmin) {
      buttons.push(
        <div className='menu-item'>
          <ConfirmButton className='button primary'
            text={'Adding this user as an Admin allows them to invite members and create events, but they cannot delete the group. Would you like to add this user as an admin?'}
            confirm='Yes'
            cancel='No'
            onConfirm={() => handleAddAdmin(member._id)}
            onCancel={toggleMenu}>
            <span className='label'>
              Add As Admin
            </span>
          </ConfirmButton>

        </div>
      )
    }

    return (
      <div className='member'>
        {
          hasMenu &&
          <div ref = {menuRef} className='menu-button' onClick={toggleMenu}>
            <FontAwesomeIcon icon={faBars} />
            <div className='menu'>
              <div className={`buttons ${isMenuOpen ? 'open' : ''}`}>
                {buttons}
              </div>
            </div>
          </div>
        }
        <UserCard className={`member-card ${isMenuOpen ? 'selected': ''} ${group.owner._id === member._id ? 'owner' : ''}`} user={member} />
      </div>)
  }


  return (<div className={className}>
    {
      group.members.map((member, i) => 
      <MemberCard 
      key={i} 
      member={member} 
      onRemoveMember={onRemoveMember}
      onAddAdmin={onAddAdmin} />)
    }
  </div>
  );
})`${styles}`

export default MemberPanel;